// Floor plan ("unit") endpoints — docs/real-estate/be/10-api-reference.md §A5.
import { request } from './http';

export function listUnits(pid) {
  return request({ path: `/properties/${pid}/units` });
}

export function createUnit(pid, fields) {
  return request({
    method: 'post',
    path: `/properties/${pid}/units`,
    data: fields,
  });
}

export function patchUnit(pid, unitId, fields) {
  return request({
    method: 'patch',
    path: `/properties/${pid}/units/${unitId}`,
    data: fields,
  });
}

export function deleteUnit(pid, unitId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/units/${unitId}`,
  });
}

export function reorderUnits(pid, unitIds) {
  return request({
    method: 'put',
    path: `/properties/${pid}/units/order`,
    data: { unit_ids: unitIds },
  });
}
